var UrlResolverV5 = (function () {
    function UrlResolverV5() {
    }
    UrlResolverV5.prototype.resolveUrl = function (action) {
        return this.formatUrl(action.controller, action.action, action.receiverId, action.queryString);
    };
    UrlResolverV5.prototype.formatUrl = function (controller, action, target, queryString) {
        var url = '';
        if (controller && controller.length > 0) {
            url += controller;
        }
        if (action && action.length > 0) {
            if (url.length > 0) {
                url += '/';
            }
            url += action;
        }
        if (target && target.length > 0) {
            if (url.length > 0) {
                url += '/';
            }
            url += target;
        }
        if (queryString && queryString.length > 0) {
            if (url.length > 0) {
                url += '/';
            }
            url += "?".concat(queryString);
        }
        return url;
    };
    return UrlResolverV5;
}());
export { UrlResolverV5 };
